<script>
  import Person from '../../../people/components/person';

  export let value;
</script>

<div class="grid-x grid-margin-x small-up-1 medium-up-3">
  {#each value.people as person, i}
  <div class="cell">
    <Person person="{person}"></Person>
  </div>
  {/each}
</div>
